import { Link } from 'react-router-dom'
import { getOptimizedImageUrl } from '../lib/utils'

export default function Footer() {
  const logoUrl = 'https://assets.auxodev.dk/assets/d6e713fb-6411-4075-ab6a-5936b7a50d5a/2dee4a-bc37f76e4fec45df81ec63fedfb4e897-mv2.png'

  return (
    <footer className="border-t border-white/10 bg-[#0E0E10] text-[#A8A49C] relative z-10">
      {/* Main footer columns */}
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* Col 1: Brand & Bio */}
          <div className="space-y-4">
            <Link to="/" className="inline-flex group">
              <div className="border-l border-white/20 pl-3.5 flex flex-col">
                <span className="font-serif text-lg tracking-wide text-[#F5F3EF] group-hover:text-[#C87D46] transition-colors font-medium leading-tight">
                  JARC Audio
                </span>
                <span className="text-xs uppercase tracking-widest text-[#A8A49C] mt-0.5">
                  HiFi & Lyd
                </span>
              </div>
            </Link>
            <p className="font-serif italic text-sm text-[#E5E2DB]">
              “Musik med nerve”
            </p>
            <p className="text-xs leading-relaxed text-[#A8A49C]">
              HiFi og DIY HiFi, højtalerbyg på bestilling, præcisionsudmåling med CLIO pocket og forhandling af Hypex Class D elektronik.
            </p>
            <div className="pt-2 text-xs text-[#716E68]">
              CVR: 39150255
            </div>
          </div>

          {/* Col 2: Navigation */}
          <div>
            <h4 className="font-serif text-sm tracking-wider uppercase text-[#F5F3EF] mb-4">
              Navigation
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/" className="hover:text-[#C87D46] transition-colors">
                  Hjem
                </Link>
              </li>
              <li>
                <Link to="/hifi" className="hover:text-[#C87D46] transition-colors">
                  HiFi / JARC Audio
                </Link>
              </li>
              <li>
                <Link to="/om-mig" className="hover:text-[#C87D46] transition-colors">
                  Om mig
                </Link>
              </li>
              <li>
                <Link to="/ydelser" className="hover:text-[#C87D46] transition-colors">
                  Ydelser
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-[#C87D46] transition-colors">
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Adresser */}
          <div>
            <h4 className="font-serif text-sm tracking-wider uppercase text-[#F5F3EF] mb-4">
              Adresser
            </h4>
            <div className="space-y-4 text-sm">
              <div>
                <span className="block text-xs uppercase tracking-wider text-[#C87D46] font-medium">
                  Adresse / Lytterum
                </span>
                <p className="text-[#E5E2DB] mt-0.5">Toftehøj 21</p>
                <p className="text-[#E5E2DB]">6470 Sydals</p>
              </div>
              <div>
                <span className="block text-xs uppercase tracking-wider text-[#C87D46] font-medium">
                  Produktionsadresse
                </span>
                <p className="text-[#E5E2DB] mt-0.5">Huholt 1A</p>
                <p className="text-[#E5E2DB]">6400 Sønderborg</p>
              </div>
            </div>
          </div>

          {/* Col 4: Kontakt */}
          <div>
            <h4 className="font-serif text-sm tracking-wider uppercase text-[#F5F3EF] mb-4">
              Direkte kontakt
            </h4>
            <div className="space-y-3 text-sm">
              <div>
                <span className="text-xs text-[#716E68] block">Telefon:</span>
                <a
                  href="tel:+4522884536"
                  className="font-medium text-[#F5F3EF] hover:text-[#C87D46] transition-colors whitespace-nowrap inline-flex items-center gap-1.5"
                >
                  <i className="fa-solid fa-phone text-[#C87D46] text-xs" aria-hidden="true" />
                  <span className="whitespace-nowrap">+45 22 88 45 36</span>
                </a>
              </div>
              <div>
                <span className="text-xs text-[#716E68] block">E-mail:</span>
                <a
                  href="mailto:jens@jarcon.dk"
                  className="font-medium text-[#F5F3EF] hover:text-[#C87D46] transition-colors whitespace-nowrap inline-flex items-center gap-1.5"
                >
                  <i className="fa-solid fa-envelope text-[#C87D46] text-xs" aria-hidden="true" />
                  <span className="whitespace-nowrap">jens@jarcon.dk</span>
                </a>
              </div>
              <p className="text-xs text-[#716E68] pt-2">
                Ring eller skriv for at få en dialog om ønsker og muligheder for at skabe din helt egen højtaler.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom copyright & attribution */}
        <div className="mt-12 border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#716E68]">
          <p>© {new Date().getFullYear()} JARCon ApS. Alle rettigheder forbeholdes.</p>
          <p className="flex items-center gap-1.5">
            <span className="text-[#C87D46]">JARC Audio</span>
            <span>– Specialiseret HiFi & Lytterum</span>
          </p>
        </div>
      </div>
    </footer>
  )
}
